var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 112.749 107.672",
    style: {
      enableBackground: "new 0 0 112.749 107.672"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC629"
    },
    d: "M60.411,2.509l13.934,28.233c0.656,1.328,1.923,2.249,3.389,2.462l31.156,4.527 c3.692,0.536,5.166,5.074,2.495,7.678L88.839,67.385c-1.061,1.034-1.545,2.524-1.295,3.984l5.322,31.031 c0.631,3.677-3.229,6.481-6.531,4.745L58.469,92.494c-1.311-0.689-2.878-0.689-4.189,0l-27.867,14.651 c-3.302,1.736-7.162-1.068-6.531-4.745l5.322-31.031c0.25-1.46-0.234-2.95-1.295-3.984L1.364,45.409 c-2.672-2.604-1.197-7.141,2.495-7.678l31.156-4.527c1.466-0.213,2.733-1.134,3.389-2.462L52.338,2.509 C53.989-0.836,58.76-0.836,60.411,2.509z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a33d1fd3.svg";
export { ForwardRef as ReactComponent };